








































































import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "Digitalisation"
})
export default class Digitalisation extends Vue {}
